export class ScrollActive {
    init()
    {
        $(window).scroll(function() {
            var scrollDistance = $(window).scrollTop()  + 200;

            // Assign active class to nav links while scolling
            $('.header').each(function(i) {
                if ($(this).position().top <= scrollDistance) {
                    $('.side-menu li').removeClass('active');
                    $('.side-menu li').eq(i).addClass('active');
                }
            });
        }).scroll();
    }
}
